var map = {
	"./tool-card.svg": "8197",
	"./tool-checklist.svg": "10ce",
	"./tool-circle.svg": "5c65",
	"./tool-comment.svg": "8ee4",
	"./tool-data-base.svg": "c327",
	"./tool-diamond.svg": "5d9c",
	"./tool-doc.svg": "44d0",
	"./tool-ellipse.svg": "a7b5",
	"./tool-graffiti.svg": "44c2",
	"./tool-list.svg": "93a5",
	"./tool-parallelogram-right.svg": "8bb7",
	"./tool-parallelogram.svg": "a566",
	"./tool-square.svg": "d99e",
	"./tool-star.svg": "7c2a",
	"./tool-trapezoid.svg": "76de",
	"./tool-triangle-bottom.svg": "c6d5",
	"./tool-triangle-left.svg": "ed60",
	"./tool-triangle-right.svg": "c242",
	"./tool-triangle-top.svg": "b328",
	"./tool-upload.svg": "881d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b3f";